const REFERER_ID = 'referer_id';

export const getCurrentRefererId = (): string | null => {
  return localStorage.getItem(REFERER_ID);
};

export const setRefererIdInLocalStorage = (value: string) => {
  localStorage.setItem(REFERER_ID, value);
};

export const removeRefererIdInLocalStorage = () => {
  localStorage.removeItem(REFERER_ID);
};
